import React, { useContext, useEffect, useState } from "react";
import {
  Modal,
  Form,
  Input,
  Button,
  DatePicker,
  message,
} from "antd";
import dayjs from "dayjs";
import { assignOpServicesApi } from "../../../../services/opservices.services";
import { UserContext } from "../../../../context/UserContext";
import { getCookie } from "../../../../helpers/localStorage";
import { FacilityID } from "../../../../constants/defaultKeys";
import { validateConfig } from "../../../../config/validate.config";
import { useSearchParams } from "react-router-dom";
import inputStyles from "../../../../styles/Custom/Input.module.css";
import modalStyles from "../../DeleteReasonModal.module.css";

const AssignOpServiceModal = ({
  open,
  setOpen,
  editData,
  refresh,
  patientId,
}) => {
  const [form] = Form.useForm();
  const { userDetails } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const admissionId = patientId || searchParams.get("admission");
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== "undefined"
      ? window.matchMedia("(max-width: 768px)").matches
      : false
  );

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 768px)");
    const onChange = () => setIsMobile(mq.matches);
    onChange();
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  const onFinish = (values) => {
    setLoading(true);

    const selectedDate = dayjs(values?.date).format("YYYY-MM-DD");

    assignOpServicesApi({
      op_admission: Number(admissionId),
      service: editData?.id,
      from_date: selectedDate,
      till_date: selectedDate,
      price: editData?.cash_price,
      facility: Number(getCookie(FacilityID)) || userDetails?.currFacility,
      comments: values?.comments,
    })
      .then((res) => {
        message.success(res?.data?.message || "Service assigned successfully!");
        refresh();
        setTimeout(() => setOpen(false), 500);
      })
      .catch((err) => {
        message.error(
          err?.response?.data?.message || "Failed to assign service"
        );
      })
      .finally(() => setLoading(false));
  };

  const footer = [
    <Button key="cancel" onClick={() => setOpen(false)}>
      Cancel
    </Button>,
    <Button
      key="save"
      type="primary"
      loading={loading}
      onClick={() => form.submit()}
    >
      Save
    </Button>,
  ];

  return (
    <Modal
      title="Assign OP Service"
      open={open}
      onCancel={() => setOpen(false)}
      centered={!isMobile}
      width={isMobile ? "min(400px, calc(100vw - 24px))" : undefined}
      wrapClassName={isMobile ? modalStyles.compactModalWrap : undefined}
      footer={footer}
      destroyOnClose
      styles={
        isMobile
          ? {
              body: {
                maxHeight: "min(70vh, 420px)",
                overflowY: "auto",
              },
            }
          : undefined
      }
    >
      <Form
        layout="vertical"
        onFinish={onFinish}
        form={form}
        className={isMobile ? modalStyles.compactFormItem : undefined}
        initialValues={{
          date: dayjs(),
        }}
      >
        <Form.Item
          label="Date"
          name="date"
          rules={validateConfig.isRequired("Date")}
        >
          <DatePicker
            className={inputStyles.mdDateInput}
            style={{ width: "100%" }}
            placement="bottomLeft"
            getPopupContainer={() => document.body}
            popupClassName="assign-op-service-date-picker curengo-mobile-picker"
            popupStyle={{
              maxWidth: "min(100vw - 24px, 280px)",
            }}
          />
        </Form.Item>

        <Form.Item label="Info" name="comments" style={{ marginBottom: 0 }}>
          <Input.TextArea
            placeholder="Enter Info (optional)"
            rows={isMobile ? 3 : undefined}
            className={inputStyles.mdInput}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AssignOpServiceModal;
